(() => {
  function initializeDolobitesReviewV3() {
    const booking = document.querySelector('.db-booking');

    if (
      !booking ||
      booking.dataset.reviewV3Initialized === 'true'
    ) {
      return;
    }

    const reviewPanel = booking.querySelector('[data-step="8"]');
    const finalSummary = booking.querySelector('#db-final-summary');
    const reviewTotal = booking.querySelector('#db-review-total');
    const reviewDeposit = booking.querySelector('#db-review-deposit');
    const reviewBalance = booking.querySelector('#db-review-balance');
    const submitButton = booking.querySelector(
      '.db-booking__checkout-button'
    );

    if (
      !reviewPanel ||
      !finalSummary ||
      !reviewTotal ||
      !reviewDeposit ||
      !reviewBalance
    ) {
      return;
    }

    booking.dataset.reviewV3Initialized = 'true';

    const getText = (
      selector,
      fallback = 'Not selected'
    ) => {
      const element = booking.querySelector(selector);

      if (!element) {
        return fallback;
      }

      const value =
        'value' in element
          ? element.value.trim()
          : element.textContent?.trim();

      return value || fallback;
    };

    const parseCurrency = (value) => {
      const number = Number(
        String(value).replace(/[^0-9.-]/g, '')
      );

      return Number.isFinite(number)
        ? number
        : 0;
    };

    const formatCurrency = (amount) => {
      const numericAmount =
        Number(amount) || 0;

      const hasDecimals =
        Math.round(numericAmount * 100) % 100 !== 0;

      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: 2
      }).format(numericAmount);
    };

    const createReviewRow = (
      label,
      value,
      className = ''
    ) => {
      const row =
        document.createElement('div');

      row.className =
        'db-booking__review-row';

      if (className) {
        row.classList.add(className);
      }

      const labelElement =
        document.createElement('span');

      labelElement.textContent = label;

      const valueElement =
        document.createElement('strong');

      valueElement.textContent =
        value || 'Not selected';

      row.append(
        labelElement,
        valueElement
      );

      return row;
    };

    const createSection = (
      eyebrow,
      title
    ) => {
      const section =
        document.createElement('section');

      section.className =
        'db-booking__review-section';

      const heading =
        document.createElement('div');

      heading.className =
        'db-booking__review-section-heading';

      const eyebrowElement =
        document.createElement('span');

      eyebrowElement.className =
        'db-booking__review-eyebrow';

      eyebrowElement.textContent =
        eyebrow;

      const titleElement =
        document.createElement('h4');

      titleElement.textContent =
        title;

      heading.append(
        eyebrowElement,
        titleElement
      );

      section.appendChild(heading);

      return section;
    };

    const updateReview = () => {
      const date =
        getText('#db-summary-date');

      const eventType =
        getText('#db-summary-event');

      const location =
        getText('#db-summary-location');

      const guests =
        getText(
          '#db-summary-guests',
          'Not selected'
        );

      const experience =
        getText('#db-summary-package');

      const flavours =
        getText('#db-summary-flavours');

      const extras =
        getText(
          '#db-summary-extras',
          'None'
        );

      const travelFeeText =
        getText(
          '#db-summary-travel',
          '$0'
        );

      const firstName =
        getText(
          '#db-customer-first-name',
          ''
        );

      const lastName =
        getText(
          '#db-customer-last-name',
          ''
        );

      const email =
        getText(
          '#db-customer-email',
          ''
        );

      const phone =
        getText(
          '#db-customer-phone',
          ''
        );

      const notes =
        getText(
          '#db-customer-notes',
          ''
        );

      const totalText =
        getText(
          '#db-summary-total',
          '$0'
        );

      const depositText =
        getText(
          '#db-summary-deposit',
          '$0'
        );

      const total =
        parseCurrency(totalText);

      const deposit =
        parseCurrency(depositText);

      const balance =
        Math.max(total - deposit, 0);

      finalSummary.innerHTML = '';

      /*
       * EVENT
       */
      const eventSection =
        createSection(
          '01',
          'Event details'
        );

      eventSection.append(
        createReviewRow(
          'Date',
          date
        ),

        createReviewRow(
          'Celebration',
          eventType
        ),

        createReviewRow(
          'Location',
          location
        ),

        createReviewRow(
          'Guests',
          guests
        )
      );

      /*
       * EXPERIENCE
       */
      const experienceSection =
        createSection(
          '02',
          'Gelato experience'
        );

      experienceSection.append(
        createReviewRow(
          'Experience',
          experience
        ),

        createReviewRow(
          'Flavours',
          flavours
        ),

        createReviewRow(
          'Extras',
          extras
        ),

        createReviewRow(
          'Travel fee',
          travelFeeText
        )
      );

      /*
       * CUSTOMER
       */
      const customerSection =
        createSection(
          '03',
          'Contact details'
        );

      const fullName =
        `${firstName} ${lastName}`.trim() ||
        'Not provided';

      customerSection.append(
        createReviewRow(
          'Name',
          fullName
        ),

        createReviewRow(
          'Email',
          email || 'Not provided'
        ),

        createReviewRow(
          'Phone',
          phone || 'Not provided'
        )
      );

      if (notes) {
        customerSection.append(
          createReviewRow(
            'Event notes',
            notes,
            'db-booking__review-row--notes'
          )
        );
      }

      finalSummary.append(
        eventSection,
        experienceSection,
        customerSection
      );

      /*
       * PRICING
       */
      reviewTotal.textContent =
        formatCurrency(total);

      reviewDeposit.textContent =
        formatCurrency(deposit);

      reviewBalance.textContent =
        formatCurrency(balance);

      /*
       * SUBMIT BUTTON
       */
      if (submitButton) {
        submitButton.textContent =
          'Submit booking request';

        const customerIsValid =
          Boolean(
            window.DOLOBITES_V3_CUSTOMER
              ?.isValid
          );

        const termsAccepted =
          Boolean(
            window.DOLOBITES_V3_CONSENT
              ?.termsAccepted
          );

        const depositAccepted =
          Boolean(
            window.DOLOBITES_V3_CONSENT
              ?.depositAccepted
          );

        submitButton.disabled =
          !customerIsValid ||
          !termsAccepted ||
          !depositAccepted;
      }
    };

    const observer =
      new MutationObserver(() => {
        if (
          reviewPanel.classList.contains(
            'is-active'
          )
        ) {
          window.setTimeout(
            updateReview,
            0
          );
        }
      });

    observer.observe(reviewPanel, {
      attributes: true,
      attributeFilter: ['class']
    });

    document.addEventListener(
      'dolobites:pans-change',
      updateReview
    );

    document.addEventListener(
      'dolobites:location-change',
      updateReview
    );

    document.addEventListener(
      'dolobites:customer-change',
      updateReview
    );

    document.addEventListener(
      'dolobites:consent-change',
      updateReview
    );

    booking.addEventListener(
      'input',
      updateReview
    );

    booking.addEventListener(
      'change',
      updateReview
    );

        booking.addEventListener(
      'click',
      () => {
        window.setTimeout(
          updateReview,
          0
        );
      }
    );

    const bookingForm = booking.querySelector(
      '#db-booking-request-form'
    );

    if (bookingForm) {
      bookingForm.addEventListener(
  'submit',
  async (event) => {
    event.preventDefault();
    console.log("🚀 SUBMIT INTERCETTATO");
          const contactName = booking.querySelector(
            '#db-booking-contact-name'
          );

          const contactEmail = booking.querySelector(
            '#db-booking-contact-email'
          );

          const contactPhone = booking.querySelector(
            '#db-booking-contact-phone'
          );

          const bookingEventDate = booking.querySelector(
  '#db-booking-event-date'
);

const bookingEventTime = booking.querySelector(
  '#db-booking-event-time'
);

const bookingEventType = booking.querySelector(
  '#db-booking-event-type'
);

const bookingLocation = booking.querySelector(
  '#db-booking-location'
);

const bookingGuests = booking.querySelector(
  '#db-booking-guests'
);

const bookingExperience = booking.querySelector(
  '#db-booking-experience'
);

const bookingFlavours = booking.querySelector(
  '#db-booking-flavours'
);

const bookingExtras = booking.querySelector(
  '#db-booking-extras'
);

const bookingTravelFee = booking.querySelector(
  '#db-booking-travel-fee'
);

const bookingTotal = booking.querySelector(
  '#db-booking-total'
);

const bookingDeposit = booking.querySelector(
  '#db-booking-deposit'
);

const bookingNotes = booking.querySelector(
  '#db-booking-notes'
);

          const firstName = getText(
            '#db-customer-first-name',
            ''
          );

          const lastName = getText(
            '#db-customer-last-name',
            ''
          );

          const email = getText(
            '#db-customer-email',
            ''
          );

          const phone = getText(
            '#db-customer-phone',
            ''
          );

          const notes = getText(
            '#db-customer-notes',
            'None'
          );

          const date = getText(
            '#db-summary-date'
          );

          const eventTime = getText(
            '#db-event-time'
          );

          const eventType = getText(
            '#db-summary-event'
          );

          const location = getText(
            '#db-summary-location'
          );

          const guests = getText(
            '#db-summary-guests'
          );

          const experience = getText(
            '#db-summary-package'
          );

          const flavours = getText(
            '#db-summary-flavours'
          );

          const extras = getText(
            '#db-summary-extras',
            'None'
          );

          const travelFee = getText(
            '#db-summary-travel',
            '$0'
          );

          const total = getText(
            '#db-summary-total',
            '$0'
          );

          const deposit = getText(
            '#db-summary-deposit',
            '$0'
          );

          const fullName =
            `${firstName} ${lastName}`.trim();

          if (contactName) {
            contactName.value = fullName;
          }

          if (contactEmail) {
            contactEmail.value = email;
          }

          if (contactPhone) {
            contactPhone.value = phone;
          }

         if (bookingEventDate) {
  bookingEventDate.value = date;
}

if (bookingEventTime) {
  bookingEventTime.value = eventTime;
}

if (bookingEventType) {
  bookingEventType.value = eventType;
}

if (bookingLocation) {
  bookingLocation.value = location;
}

if (bookingGuests) {
  bookingGuests.value = guests;
}

if (bookingExperience) {
  bookingExperience.value = experience;
}

if (bookingFlavours) {
  bookingFlavours.value = flavours;
}

if (bookingExtras) {
  bookingExtras.value = extras;
}

if (bookingTravelFee) {
  bookingTravelFee.value = travelFee;
}

if (bookingTotal) {
  bookingTotal.value = total;
}

if (bookingDeposit) {
  bookingDeposit.value = deposit;
}

if (bookingNotes) {
  bookingNotes.value = notes;
}

          if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent =
              'Submitting your request...';
          }          const currencyToCents = (value) => {
            const amount = Number(
              String(value).replace(/[^0-9.-]+/g, '')
            );

            return Math.round(amount * 100);
          };

          const totalCents =
            currencyToCents(total);

          const travelFeeCents =
            currencyToCents(travelFee);

          const depositCents =
            currencyToCents(deposit);

          const subtotalCents =
            totalCents - travelFeeCents;

          const guestCount = Number(
            String(guests).replace(/\D/g, '')
          );

          const rawEventDate =
            booking.querySelector('#db-event-date')?.value ||
            date;

          try {
            const response = await fetch(
              '/apps/dolobites-booking',
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                body: JSON.stringify({
                  customerName: fullName,
                  customerEmail: email,
                  customerPhone: phone,
                  eventDate: rawEventDate,
                  timeSlot: eventTime,
                  eventAddress: location,
                  city: null,
                  state: null,
                  postalCode: null,
                  guestCount,
                  experienceName: experience,
                  flavours,
                  extras,
                  customerNotes: notes,
                  subtotalCents,
                  travelFeeCents,
                  totalCents,
                  depositCents,
                }),
              }
            );

            const result = await response.json();

            if (!response.ok || !result.success) {
              throw new Error(
                result.message ||
                'Unable to submit booking request'
              );
            }

            window.location.href =
              '/pages/booking-request-received';
          } catch (error) {
            console.error(
              'Dolobites booking submission error:',
              error
            );

            if (submitButton) {
              submitButton.disabled = false;
              submitButton.textContent =
                'Submit booking request';
            }

            alert(
              'We could not submit your booking request. Please try again.'
            );
          }         
        }
      );
    }

    updateReview();
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initializeDolobitesReviewV3
    );
  } else {
    initializeDolobitesReviewV3();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeDolobitesReviewV3
  );
})();